<template>
  <div class="small">
    <pie-chart
      v-if="showChart"
      :styles="{height: '200px'}"
      :chart-data="datacollection"
      :options="chartOptions"
    />
    <div
      v-else
      class="chart-widget-blank d-flex flex-column align-items-center justify-content-center mt-5"
    >
      <div class="mt-2">
        <i
          class="far fa-chart-pie-alt fa-3x"
          aria-hidden="true"
        />
      </div>
      <span class="text-center mt-4">
        {{ $t('dashboard.widget.pendingCasesEmptyStateText') }}
      </span>
    </div>
  </div>
</template>

<script>
import dashboardService, { DASHBOARD_SITUATION_CASE_OPTIONS } from '@/api/resources/dashboard/dashboardService'
import Encoder from '@/utils/encoder'
import PieChart from '@/modules/dashboardModule/widgets/chartWidget/PieChart'

export default {
    components: {
        PieChart
    },
    props: {
        laboratoriesId: { type: Array },
        casetypesId: { type: Array },
        prioritiesId: { type: Array }
    },
    data() {
        return {
            datacollection: null,
            chartOptions: null,
            situationData: null,
            encoder: new Encoder(),
            labels: [],
            data: [],
            backgroundColor: []
        }
    },
    computed: {
        showChart() {
            return this.datacollection?.datasets?.[0]?.data?.reduce((a, b) => a + b, 0) !== 0
        }
    },
    mounted() {
        this.fillData()
        this.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false
            }
        }
    },
    methods: {
        async fillData() {
            this.clearFields()
            const filter = {
                'laboratory.labId': {
                    'filterType': 'set',
                    'values': this.laboratoriesId.map(laboratory => laboratory.labId)
                },
                'priority.id': {
                    'filterType': 'set',
                    'values': this.prioritiesId.map(priority => priority.id)
                },
                'caseType.id': {
                    'filterType': 'set',
                    'values': this.casetypesId.map(caseType => caseType.id)
                }
            }

            this.updateLoading(true)
            const [error, response] = await this.toCall(dashboardService.getSummaryCaseSituations(filter))
            if (error) {
                this.showErrorModalGlobal()
                this.updateLoading(false)
                return
            }
            this.situationData = response
            Object.keys(this.situationData).forEach(key => {
                if (DASHBOARD_SITUATION_CASE_OPTIONS[this.situationData[key].entity]) {
                    this.labels.push(this.$t(DASHBOARD_SITUATION_CASE_OPTIONS[this.situationData[key].entity].label))
                    this.data.push(this.situationData[key].count)
                    this.backgroundColor.push(DASHBOARD_SITUATION_CASE_OPTIONS[this.situationData[key].entity].bgColor)
                }
            }
            )
            this.datacollection = {
                labels: this.labels,
                datasets: [
                    {
                        label: 'Data 1',
                        backgroundColor: this.backgroundColor,
                        data: this.data
                    }
                ]
            }
            this.updateLoading(false)
        },
        clearFields() {
            this.labels = []
            this.data = []
            this.backgroundColor = []
        }
    }
}
</script>

<style>
</style>
